jQuery(document).ready(function($) {
    'use strict';

    let observer;

    function getPosition() {
        const positionMobile = 60,
              positionDesktop = 130,
              mobileWidth = 720;
        return window.innerWidth < mobileWidth ? positionMobile : positionDesktop;
    }

    function scrollToAnchor() {
        const anchorID = window.location.hash;
        if (!anchorID || anchorID === "#") return; // avoid empty selectors

        scrollToElement(document.querySelector(anchorID));
    }

    function scrollToElement(targetElement) {
        if (targetElement) {
            const offset = getPosition();
            $('html, body').animate({
                scrollTop: $(targetElement).offset().top - offset
            }, 500);
            if (observer) {
                observer.disconnect(); // Stop observer when succesfull
            }
        }
    }

    /* Scrollen to anchor on page load */
    if (window.location.hash) {
        setTimeout(scrollToAnchor, 500);
    }
    
    var element = document.querySelector('.js-scroll-into-view');
    if (element) {
        scrollToElement(element);
    }

    /* Observer for dynamic content (vergoedingen) */
    if (window.location.hash) {
        observer = new MutationObserver(() => {
            scrollToAnchor();
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }

    /* Smooth scroll on click */
    $(document).on('click', 'a:not(.topicitem)[href^="#"]', function(event) {
        const href = $(this).attr('href');

        if (href && href !== '#') {
            const targetElement = document.querySelector(href);
            if (targetElement) {
                event.preventDefault();
                $('html, body').animate({
                    scrollTop: $(targetElement).offset().top - getPosition()
                }, 500);
            }
        }
    });
});
